// libs
import { connect } from 'react-redux';

// redux
import { getProductData, getProductId, getProductOutOfStock } from 'shared/store/details/selectors';
import { getStoreId } from 'shared/store/app/selectors';

// components
import RecentlyViewedObserver from './RecentlyViewedObserver';

const mapStateToProps = (state: any) => ({
  data: getProductData(state) as ProductDetail.IProduct,
  productID: getProductId(state),
  isOutOfStock: getProductOutOfStock(state),
  storeId: getStoreId(state),
});

export default connect(mapStateToProps)(RecentlyViewedObserver);
